import { render, staticRenderFns } from "./TransferNote.vue?vue&type=template&id=45b71cec&scoped=true"
import script from "./TransferNote.vue?vue&type=script&lang=js"
export * from "./TransferNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b71cec",
  null
  
)

export default component.exports